import { BADGE_DESCRIPTIONS } from 'features/catalog/badge-definitions';
import { DEFAULT_BADGE_DATE_ADDED, formatDateAddedLockLabel, isDateAddedVisible } from 'features/catalog/date-added';

export {
  catalogMsNudgedBelowEarlierSameDayClaim,
  DEFAULT_BADGE_DATE_ADDED,
  formatDateAddedLockLabel,
  isDateAddedVisible,
  parseDateAdded,
} from 'features/catalog/date-added';

/** True when a badge’s catalog `dateAdded` has been reached (claimable / feed-visible). */
export const isBadgeReleased = (badgeId: string, now = new Date()): boolean => {
  const dateAdded = BADGE_DESCRIPTIONS.get(badgeId)?.dateAdded ?? DEFAULT_BADGE_DATE_ADDED;
  return isDateAddedVisible(dateAdded, now);
};

/** Claim-style lock line while `dateAdded` is still in the future. Null once released. */
export const unreleasedLockLine = (badgeId: string, now = new Date()): string | null => {
  if (isBadgeReleased(badgeId, now)) return null;
  const unlocks = BADGE_DESCRIPTIONS.get(badgeId)?.dateAdded ?? DEFAULT_BADGE_DATE_ADDED;
  return `🔒 Releases on: ${formatDateAddedLockLabel(unlocks)}`;
};
